import { render, staticRenderFns } from "./OrderSummary.vue?vue&type=template&id=bb1e3af6&"
import script from "./OrderSummary.vue?vue&type=script&lang=js&"
export * from "./OrderSummary.vue?vue&type=script&lang=js&"
import style0 from "./OrderSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports